import React, { useEffect } from "react";

import { css } from "@emotion/react";
import { useGetExpertHome } from "@src/hooks/queries/useExpert";
import { useNavigate, useLocation } from "react-router-dom";
import { Common } from "@src/styles/Common";
import { userCountInfo } from "../Home";

const RefundBox = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const { data, refetch } = useGetExpertHome();
    const handleClick = () => {
        navigate("/payment/list");
    };

    useEffect(() => {
        refetch();
    }, []);
    return (
        <div css={expertStatBox} onClick={handleClick}>
            <div>
                <div css={userCountInfo} className="cursor" onClick={handleClick}>
                    <p
                        style={{
                            width: "100%",
                            fontWeight: "bold",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: "14px",
                        }}
                    >
                        <span>전문가매칭 환불 관리</span>
                        <span style={{ fontSize: "16px" }}>{" > "}</span>
                    </p>
                </div>
                <div css={userCountInfo}>
                    <p>환불 요청</p>
                    <p className="countText">0</p>
                </div>
                <div css={userCountInfo}>
                    <p>환불 완료</p>
                    <p className="countText">0</p>
                </div>
                {/* <div
                    css={userCountInfo}
                    className="cursor"
                    onClick={() => {
                        console.log("click");
                    }}
                >
                    <p>등록자 수</p>
                    <p className="countText">{data?.auctionAgentCount}</p>
                </div> */}
            </div>
        </div>
    );
};

export default RefundBox;

const expertStatBox = css`
    box-sizing: border-box;
    height: 120px;
    border: 1.5px solid ${Common.colors.gray200};
    border-radius: 8px;
    padding: 14px 20px;
    display: flex;
    flex-direction: column;
    gap: 6px;
`;
